import { HttpContextToken } from "@angular/common/http";

export const DISABLE_TOAST = new HttpContextToken<boolean | null | ((error: unknown) => boolean | null)>(() => null);
